export const subscriptionData = {
  id: 1,
  title: "Subscribe",
  content:
    "Get the latest insights and research delivered straight to your inbox.",
}
